import { lazy } from 'react';

const ForecastSalesReport = lazy(() => import('./ForecastSalesReport'));

const ForecastSalesReportConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/sales/reports/forecastSalesReport',
            element: <ForecastSalesReport />,
        },
    ],
};

export default ForecastSalesReportConfig;